import { Component, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CompanyService } from './company.service';
import { Module } from 'app/shared/model/module.model';
import { AuthService } from 'app/shared/auth/auth.service';
import { UserQuota } from 'app/shared/model/userquota.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { BreezeService } from 'app/shared/service/breeze.service';
import { NgxSpinnerService } from 'ngx-spinner';
declare var grecaptcha: any;
@Component({
  selector: 'company',
  templateUrl: './company.component.html'
})
export class CompanyComponent implements OnInit {
  url:string;
  company:string;
  modules: Module[];
  breezeSessionString: string;

  paramSubQuotaSession: Subscription;
  userQuota: UserQuota = new UserQuota();
  sessionFlag: boolean = false;
  quotaFlag: boolean = false;
  public modalRef: BsModalRef; 

  @ViewChild('modalSession') modalSessionTemp: TemplateRef<any>;
  @ViewChild('modalQuota') modalQuotaTemp: TemplateRef<any>;

  constructor(private _formBuilder: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _companyService: CompanyService,private authService: AuthService,
    private breezeService: BreezeService,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService) {

  }


  ngOnInit() {
    this.url=this._router.url;
    this.url= this.url.replace("/","");
    console.log(this._router);
    console.log(this._router.url);
    this.getModules(this.url);
    this.breezeSessionString = this.authService.getBreezeSessionString();
  }

  getModules(url:string){
    this._companyService.getModules(url).subscribe(resp=>{
      console.log(resp);
      let urls=resp.promotionalUrls;
      this.modules=resp.modules;
      if(this.modules.length >0){
        this.company=urls.vTitle;
      }else{
      this.company="Page not found";
      }
    });
  }


  checkBreezeQuotaSession(module){

    console.log('Going through Breeze Service');

    this.breezeService.checkBothQuotaAndSession(module, this.spinner, this.modalSessionTemp, this.modalQuotaTemp, this.modalRef, this.modalService)

  }

  callCloseModal(){

    console.log('Going through callCloseModal in Breeze Service')

    this.breezeService.closeModal();

  }


}



// WEBPACK FOOTER //
// ./src/app/company/company.component.ts